import { gql } from "@apollo/client";

import organizationTalentIndicatorFragment from "./organization-talent-indicator-fragment";

export default gql`
  ${organizationTalentIndicatorFragment}
  query getOrganizationTalentIndicators($organizationId: Int!) {
    talentIndicators(organizationId: $organizationId) {
      edges {
        node {
          ...OrganizationTalentIndicator
        }
      }
    }
  }
`;
